import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/* `useGrouping` non è un vezzo: in italiano il raggruppamento predefinito
   ('auto') salta i numeri di quattro cifre, perché il CLDR chiede almeno due
   cifre prima del separatore. Risultato misurato: nella stessa colonna si
   leggeva "4800" e "12.500", e nella stessa fascia "2175" e "26.102".
   Si passa `true`, non la stringa 'always', perché il `lib` di TypeScript è
   fermo a ES2022 e non conosce ancora le stringhe di Intl v3; a runtime `true`
   viene normalizzato proprio in 'always' (verificato con resolvedOptions()).
   Da cinque cifre in su non cambia niente. */
const eur = new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0, useGrouping: true });
const eurFull = new Intl.NumberFormat('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: true });

export function fmtEur(n: number | string | null | undefined, full = false): string {
  if (n == null || n === '') return '—';
  const num = typeof n === 'string' ? Number(n) : n;
  if (!Number.isFinite(num)) return '—';
  return full ? eurFull.format(num) : eur.format(num);
}

export function fmtDate(d: string | Date | null | undefined): string {
  if (!d) return '—';
  const date = typeof d === 'string' ? new Date(d) : d;
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' });
}

export function fmtDateShort(d: string | Date | null | undefined): string {
  if (!d) return '—';
  const date = typeof d === 'string' ? new Date(d) : d;
  return date.toLocaleDateString('it-IT', { day: '2-digit', month: 'short' });
}

export function initialsOf(first: string, last: string): string {
  return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
}

export function nameInitials(name: string): string {
  return name.split(' ').map((s) => s.charAt(0)).join('').slice(0, 2).toUpperCase();
}

export function calcMargin(revenue: number, cost: number) {
  const abs = revenue - cost;
  const pct = revenue > 0 ? +((abs / revenue) * 100).toFixed(2) : 0;
  return { abs, pct };
}
